import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';
import { IPageList } from '../../interfaces';
import { useChildrenOfPage, usePagesStoreCurrentComponent, useRouterStore, useUiSearch } from '../../hooks';
import { setUiLastViewComponentName } from '../../middleware';
import { dateText2Utc, lightText, replaceSpacesNonBreaking } from '../../instruments';
import { tI } from '../../translate';
import Styles from './m_styles.less';

interface ILinkComponent {
    id?: string | number;
    currentListComponent?: IPageList;
    deletedAt?: string;
    isDelete?: boolean;
    isFilterCurrentView?: boolean;
    isLight?: boolean;
    isOpenAsEdit?: boolean;
    name?: string | number | null;
    localSearch?: string;
}

// ToDo: 24.01.2025 - add OnClick reaction and use is with # url for isMyLink

export const LinkComponent: React.FC<ILinkComponent> = observer(
    ({
        id,
        currentListComponent,
        deletedAt,
        isDelete,
        isFilterCurrentView,
        isLight,
        isOpenAsEdit,
        name,
        localSearch,
    }: ILinkComponent) => {
        const idStr = typeof id === 'number' ? String(id) : id;
        const routerStore = useRouterStore();
        const currentComponent = usePagesStoreCurrentComponent();
        const currentList = currentListComponent || (currentComponent.routeName as IPageList);
        const childrenPages = useChildrenOfPage(currentList, idStr);
        const componentName = isOpenAsEdit ? childrenPages.editComponentName : childrenPages.viewComponentName;
        const componentIsRight = isOpenAsEdit ? childrenPages.editComponentIsRight : childrenPages.viewComponentIsRight;
        const componentLink = isOpenAsEdit ? childrenPages.editComponentLink : childrenPages.viewComponentLink;
        const search = useUiSearch();
        const isMyLink =
            componentName === routerStore?.routerState?.routeName && idStr === routerStore?.routerState?.params?.idStr;
        const showName: string = name ? (typeof name === 'string' ? name : name.toString()) : `#\u00A0${idStr}`;
        const lightName =
            isLight && (localSearch || search)
                ? lightText(showName, localSearch || search)
                : replaceSpacesNonBreaking(showName);
        const title = (
            !!deletedAt
                ? `${name} - ${tI('Deleted at')}: ${dateText2Utc(deletedAt)}`
                : isDelete
                ? `${name} - ${tI('Deleted')}`
                : lightName
        ) as string | undefined;

        if (!idStr && !name) {
            return null;
        } else if (componentIsRight && idStr && !isMyLink) {
            const goTo = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
                if (!(event.ctrlKey || event.metaKey || event.altKey || event.shiftKey)) {
                    event.preventDefault();
                    if (isFilterCurrentView) {
                        setUiLastViewComponentName('About');
                    }
                    routerStore.goTo(componentName, { params: { id: idStr } }).then();
                }
            };

            return (
                <a
                    onClick={goTo}
                    href={componentLink}
                    className={cx(
                        Styles.item,
                        Styles.linkItem,
                        isDelete || !!deletedAt ? Styles.deleteItem : Styles.activeItem,
                    )}
                    title={title}
                >
                    {lightName}
                </a>
            );
        } else {
            return (
                <span title={title} className={cx(Styles.item, isDelete ? Styles.deleteItem : Styles.textItem)}>
                    {lightName}
                </span>
            );
        }
    },
);
